import React, { useState, useEffect } from "react";
import { generateReceipt } from "../../utils/receiptGenerator";
import "../../assets/styles/payment.css";

const API = "https://shuttle-craft-student-transport.onrender.com";

function AddPayment() {
  const [students, setStudents] = useState([]);

  const [selectedStudent, setSelectedStudent] = useState("");
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");

  const [amount, setAmount] = useState("");
  const [status] = useState("Paid");

  const [batch, setBatch] = useState("");
  const [coach, setCoach] = useState("");
  const [slot, setSlot] = useState("");

  const [paymentMode, setPaymentMode] = useState("Cash");
  const [date, setDate] = useState("");

  // ✅ FETCH STUDENTS
  useEffect(() => {
    fetch(`${API}/api/students`)
      .then((res) => res.json())
      .then((data) => setStudents(data))
      .catch((err) => console.log(err));
  }, []);

  // ✅ GENERATE SLOTS
  const generateSlots = () => {
    const slots = [];

    for (let i = 4; i < 23; i++) {
      let next = i + 1;

      const format = (h) => {
        const period = h >= 12 ? "PM" : "AM";
        const hour = h % 12 === 0 ? 12 : h % 12;
        return `${hour}:00 ${period}`;
      };

      slots.push(`${format(i)} - ${format(next)}`);
    }

    return slots;
  };

  const slots = generateSlots();

  // ✅ HANDLE STUDENT SELECT
  const handleStudentChange = (e) => {
    const id = String(e.target.value);
    setSelectedStudent(id);

    const student = students.find((s) => String(s._id) === id);

    if (student) {
      setStudentId(student._id);
      setStudentName(student.name);
      setBatch(student.batch || "");
      setCoach(student.coach || "");
      setSlot(student.slot || "");
    }
  };

  // ✅ SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API}/api/payments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          studentId,
          studentName,
          amount: Number(amount),
          status,
          batch,
          coach,
          slot,
          paymentMode,
          date,
        }),
      });

      const savedPayment = await response.json();

      alert("Payment Added Successfully ✅");

      generateReceipt({
        ...savedPayment,
        amount: parseInt(amount),
      });

    } catch (error) {
      console.log("Payment Error:", error);
    }
  };

  return (
    <div className="payment-page">
      <h2>Add Payment</h2>

      <form className="payment-form" onSubmit={handleSubmit}>

        {/* SELECT STUDENT */}
        <div className="form-group">
          <label>Select Student</label>
          <select value={selectedStudent} onChange={handleStudentChange}>
            <option value="">Select Student</option>
            {students.map((student) => (
              <option key={student._id} value={student._id}>
                {student.name}
              </option>
            ))}
          </select>
        </div>

        {/* STUDENT ID */}
        <div className="form-group">
          <label>Student ID</label>
          <input type="text" value={studentId} readOnly />
        </div>

        {/* AMOUNT */}
        <div className="form-group">
          <label>Amount</label>
          <input
            type="number"
            placeholder="Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        {/* ✅ BATCH DROPDOWN (PROFESSIONAL BACK) */}
        <div className="form-group">
          <label>Batch</label>
          <select value={batch} onChange={(e) => setBatch(e.target.value)}>
            <option value="">Select Batch</option>
            <option value="Beginner Level">Beginner Level</option>
            <option value="Beginner Level 1">Beginner Level 1</option>
            <option value="Beginner Level 2">Beginner Level 2</option>
            <option value="Beginner Level 3">Beginner Level 3</option>
            <option value="Intermediate">Intermediate</option>
            <option value="Semi-Advanced">Semi-Advanced</option>
            <option value="Advanced">Advanced</option>
            <option value="Pro-Advanced">Pro-Advanced</option>
            <option value="ONE-ON-ONE">ONE-ON-ONE</option>
          </select>
        </div>

        {/* COACH */}
        <div className="form-group">
          <label>Coach</label>
          <input
            type="text"
            placeholder="Coach"
            value={coach}
            onChange={(e) => setCoach(e.target.value)}
          />
        </div>

        {/* ✅ SLOT DROPDOWN (PROFESSIONAL BACK) */}
        <div className="form-group">
          <label>Slot</label>
          <select value={slot} onChange={(e) => setSlot(e.target.value)}>
            <option value="">Select Slot</option>
            {slots.map((s, index) => (
              <option key={index} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        {/* PAYMENT MODE */}
        <div className="form-group">
          <label>Payment Mode</label>
          <select
            value={paymentMode}
            onChange={(e) => setPaymentMode(e.target.value)}
          >
            <option value="Cash">Cash</option>
            <option value="UPI">UPI</option>
            <option value="Bank Transfer">Bank Transfer</option>
          </select>
        </div>

        {/* DATE */}
        <div className="form-group">
          <label>Date</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        <button className="save-payment-btn" type="submit">
          Save Payment
        </button>

      </form>
    </div>
  );
}

export default AddPayment;